function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerIconBuildingSkyscraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-building-skyscraper"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#FDB022",
    style: {
      fill: "#FDB022",
      fill: "color(display-p3 0.9913 0.6913 0.1342)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.75 12.25H12.25M2.91667 12.25V4.08333L7.58333 1.75V12.25M11.0833 12.25V6.41667L7.58333 4.08333M5.25 5.25V5.25583M5.25 7V7.00583M5.25 8.75V8.75583M5.25 10.5V10.5058",
    stroke: "#111928",
    style: {
      stroke: "#111928",
      stroke: "color(display-p3 0.0667 0.0980 0.1569)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerIconBuildingSkyscraper);
export default __webpack_public_path__ + "static/media/tabler-icon-building-skyscraper.e5504112f1980242c30cb06439055967.svg";
export { ForwardRef as ReactComponent };